import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useExpandableDescription } from '../../../../../common/hooks/useExpandableDescription';
import Button from '../../../../../common/widgets/Button';
import Icons from '../../../../../common/widgets/Icons';
import TabStrip, { TabInfo } from '../../../../../common/widgets/TabStrip';
import { resources } from '../../../resources/resources';

export interface DetailsTabProps {
  tabs: TabInfo[];
}

export default function DetailsTab({ tabs }: Readonly<DetailsTabProps>) {
  const descriptionRef = useRef<HTMLDivElement>(null);
  const { t: translate } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  const hasOverflow = useExpandableDescription(descriptionRef, isExpanded);

  return (
    <div
      ref={descriptionRef}
      className={`product-description ${hasOverflow ? 'has-overflow' : ''} ${
        isExpanded ? 'expanded' : ''
      }`}
    >
      <TabStrip tabs={tabs} />

      {hasOverflow && (
        <div className="product-description-actions">
          <Button
            onClick={() => setIsExpanded(value => !value)}
            className="product-description-toggle"
            icon={isExpanded ? <Icons.ArrowUp /> : <Icons.ArrowDown />}
          >
            <span className="product-description-toggle__text">
              {isExpanded
                ? translate(resources.products.description.collapse)
                : translate(resources.products.description.expand)}
            </span>
          </Button>
        </div>
      )}
    </div>
  );
}
